import { mapGetters, mapState } from 'vuex'

export default {
  name: 'profile',
  components: {},
  props: [],
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters([
      'getUserData',
    ])
  },
  mounted () {

  },
  methods: {

  }
}
